/* hgn-side-cart-express.js — the express pay panel in the side cart
   (2026-10-16; SIDE-CART.md "Express pay panel (2026-10-16)",
   redesigned/SIDECART-EXPRESS-DESIGN-2026-10-16.md §3).

   Shopify's wallet buttons (Shop Pay, Apple Pay, Google Pay, PayPal) can't
   wait for our Checkout-click mint: the tap happens inside Shopify's sealed
   button and charges whatever is ON the cart. So the drawer offers a
   separate "Express checkout" panel. Opening it is the shopper's "pay now":
     1. the side cart's own pre-checkout chain runs (HGNSideCart
        ._expressCheckout in assets/hgn-side-cart.js — the same chain as
        the Checkout tap, second exit, no navigation) and hands back the
        codes it would have put on /checkout?discount=…;
     2. this file puts them on the cart (POST /cart/update.js {discount}),
     3. polls /cart.js until EVERY code is there with applicable === true
        and Shopify's total_price matches the drawer's foot to the penny,
     4. and only then reveals the wallet buttons.
   Closing the panel, or any cart change while it's open, hides the wallets
   and scrubs every code the panel put on the cart. While the codes sit on
   the cart, the drawer's money maths ignores them (expressNeutralCart in
   the core) so nothing is counted twice.

   Arm family `express` (announcement bar "Express checkout arm" →
   HGN_SIDE_CART_CONFIG.attach.expressArm). Ships `off`: no entry, no
   wallets in the DOM, no events, no cart attribute. A = control (no entry),
   B = the entry. `express_eligible` fires in BOTH arms at the same moment
   (drawer open on an eligible basket). QA look: ?hgn_express=B.
   Config: HGN_SIDE_CART_CONFIG.express { minUnits, minSubtotalGbp,
   warmCheckout: 'before' | 'after' | 'off' }.

   ES5 on purpose (Shopify's asset minifier). Loaded from
   snippets/hgn-side-cart.liquid straight after the core and kit-claim. */
(function () {
  'use strict';
  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  var HGNSideCart = B.HGNSideCart;
  var P = HGNSideCart.prototype;
  if (P.__hgnExpressLoaded) return;
  P.__hgnExpressLoaded = true;
  var H = B.helpers || {};
  window.HGN = window.HGN || {};

  /* Copy approved by Matt in chat, 16 Oct 2026. */
  var COPY = {
    entry:       'Express checkout',
    entrySub:    'Shop Pay, PayPal and more',
    title:       'Express checkout',
    securing:    'Securing your discount…',
    adding:      'Adding your kit…',
    preparing:   'One moment…',
    unavailable: 'Express checkout isn’t available for this basket right now',
    regular:     'Or use regular checkout',
    close:       'Close express checkout',
    items:       'Items',
    delivery:    'Delivery',
    toPay:       'To pay',
    free:        'Free',
    atPayment:   'Added at payment'
  };

  var QA_PARAM = 'hgn_express';
  var QA_KEY = 'hgn_arm_qa_express';
  var APPLIED_KEY = 'hgn_express_applied';   /* sessionStorage: codes the panel put on the cart */
  var NP_KEY = 'hgn_express_np';             /* sessionStorage: { code, sig, at } of a panel NAILPOINTS mint */
  var NP_REUSE_MS = 50 * 60 * 1000;          /* the code lives 1 h; reuse it inside 50 min */
  var CHAIN_CAP_MS = 25000;                  /* mint 2 × 6 s + KIT5 2.5 s + code waits */
  var WARM_CAP_MS = 4000;                    /* same cap as finalGo's warm-up */
  var POLL_MS = 400;
  var WALLET_MIN_PX = 24;                    /* a rendered wallet row is ≥ 25 px (Shopify's floor) */
  var WALLET_STABLE_MS = 1200;
  var HOLD_MS = 3 * 60 * 1000;               /* after a wallet tap, an outside click doesn't close the drawer */
  var TIERS = ['classic', 'gels', 'press-ons'];

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function up(c) { return String(c || '').toUpperCase(); }
  function log() {
    try { if (window.console && console.info) console.info.apply(console, ['[hgn-side-cart-express]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* ── Arm ─────────────────────────────────────────────────────────────
     Same shape as assets/hgn-kit-claim.js, one difference: the family is
     registered only once the test is ON (or a QA pin is set), so `off`
     writes no _hgn_arm_express attribute and logs no `assigned` row. The
     QA pin is read here because registration (which normally reads it) is
     what `off` skips. */
  (function readQa() {
    try {
      var q = new URLSearchParams(location.search).get(QA_PARAM);
      if (q == null) return;
      q = up(q);
      if (q === 'A' || q === 'B') sessionStorage.setItem(QA_KEY, q);
      else sessionStorage.removeItem(QA_KEY);
    } catch (e) {}
  })();
  function switchedOff() {
    var qa = ssGet(QA_KEY);
    if (qa === 'A' || qa === 'B') return false;
    try {
      var v = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.attach && window.HGN_SIDE_CART_CONFIG.attach.expressArm;
      return v == null || v === '' || String(v) === 'off';
    } catch (e) { return true; }
  }
  var registered = false;
  function arm() {
    if (switchedOff()) return null;
    if (!registered && typeof window.HGN.registerArm === 'function') {
      window.HGN.registerArm('express', 'expressArm', { pctB: 50, qa: QA_PARAM });
      registered = true;
    }
    if (!registered || typeof window.HGN.armFor !== 'function') return null;
    var a = window.HGN.armFor('express');
    return a === 'A' || a === 'B' ? a : null;
  }

  function cfg() {
    var c = (window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.express) || {};
    var minUnits = parseInt(c.minUnits, 10);
    var minSub = parseFloat(c.minSubtotalGbp);
    var warm = String(c.warmCheckout || 'after');
    return {
      minUnits:       isFinite(minUnits) && minUnits >= 1 ? minUnits : 2,
      minSubtotalGbp: isFinite(minSub) && minSub > 0 ? minSub : 0,
      warmCheckout:   (warm === 'before' || warm === 'off') ? warm : 'after',
      verifyMs:       6000
    };
  }

  /* Events: hgn:offer:express_<name>, read by snippets/hgn-arm-beacon.liquid. */
  function offer(name, detail) {
    if (switchedOff()) return;
    detail = detail || {};
    /* Where Express was offered or opened (SIDE-CART-API-2026-10-17.md §4):
       drawer | drawer-lp | drawer-pdp, or the caller's tag from openFrom
       (dock-lp, dock-pdp, card-lp). The beacon's existing `surface` field. */
    if (!detail.surface) detail.surface = S.surface || surfaceFor('drawer');
    try { document.dispatchEvent(new CustomEvent('hgn:offer:express_' + name, { detail: detail })); } catch (e) {}
  }
  function pageTag() {
    var d = document.querySelector('[data-hgn-cart-dock]');
    var p = d ? d.getAttribute('data-hgn-dock-page') : '';
    if (p === 'meta' || document.documentElement.hasAttribute('data-hgn-arm-lp')) return 'lp';
    if (p === 'product') return 'pdp';
    return '';
  }
  function surfaceFor(base) { var t = pageTag(); return t ? base + '-' + t : base; }
  /* The side cart's state() / subscribe() re-read us on this. */
  function stateChanged() { try { document.dispatchEvent(new CustomEvent('hgn:express:state')); } catch (e) {} }

  /* ── State ─────────────────────────────────────────────────────────── */
  var S = {
    inst: null, el: null,
    open: false, phase: 'idle', run: 0,
    applied: [], attrSet: false,
    sig: null, npSigOpen: null, keep: [], pendingWrite: null, measureT: null,
    eligibleLogged: false,
    walletCloned: false, walletH: 0, walletStableSince: 0,
    walletTapAt: 0, lastOutsideDown: 0,
    scrubbing: null, lastReason: null, lastResult: null,
    total: null, ship: null, surface: '', standalone: false, opener: null
  };

  function rawCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function postUpdate(body) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  /* What the basket IS (lines, quantities, prices, properties via the key)
     — not its discounts or attributes, which the chain itself writes. */
  /* What's IN the basket — never Shopify's line keys: applying a discount
     code re-keys every line (seen on the copy theme, 16 Oct: same items, same
     prices, all-new keys, and the old keys back once the code is removed), so
     a key-based signature read the panel's own BASKET-* as a basket change
     and closed the panel the moment the code landed. */
  function lineSig(cart) {
    return ((cart && cart.items) || []).map(function (it) {
      var p = it.properties || {};
      return [it.variant_id, it.quantity, it.original_line_price != null ? it.original_line_price : it.line_price,
        p._bundle_id || '', (p._gift_line || p['Free gift']) ? 'gift' : ''].join(':');
    }).join('|');
  }
  function npSig(inst) {
    var a = (inst.cart && inst.cart.attributes) || {};
    return lineSig(inst.cart) + '#' + (a._hgn_nailpoints_amount_gbp || '') + '#' + ((inst.cart && inst.cart.currency) || '');
  }
  function npRecord() { try { return JSON.parse(ssGet(NP_KEY) || 'null'); } catch (e) { return null; } }
  function setApplied(codes) {
    S.applied = codes.slice();
    if (typeof H.setExpressCodes === 'function') H.setExpressCodes(codes);
    if (codes.length) ssSet(APPLIED_KEY, JSON.stringify(codes)); else ssDel(APPLIED_KEY);
  }

  /* ── Eligibility ─────────────────────────────────────────────────────
     Hidden (never greyed) unless ALL hold: lines in the cart; the "meaty"
     rule; no kit building or unfinalised; nothing busy or minting; not in
     the "Continue without discount" state; then arm B + a rendered wallet
     for the entry itself. */
  function isGift(it) { try { return typeof H.isGiftLineItem === 'function' && H.isGiftLineItem(it); } catch (e) { return false; } }
  function isKitLine(it) {
    var p = (it && it.properties) || {};
    var bt = String(p._bundle_type || '');
    return /-starter-kit/.test(bt) || p._bundle_price_gbp_cents != null;
  }
  /* A COMPLETE kit (designs + every required item) still in the builder, not
     yet in the cart — the state the foot shows as "Checkout with my kit".
     Matt, 16 Oct: the side cart's three states (non-kit only · kit only · kit
     + non-kit) get the same experience, so express is offered here too and
     its open adds the kit first (finaliseReadyKit below). Returns the tier. */
  function readyKitTier(inst) {
    try {
      var info = typeof inst._findUnfinalisedReadyKit === 'function' ? inst._findUnfinalisedReadyKit() : null;
      if (!info || !info.tier) return null;
      var f = typeof window.HGN.kitFinaliseState === 'function' ? window.HGN.kitFinaliseState(info.tier) : null;
      return (f && f.ready && f.unfilled === 0) ? info.tier : null;
    } catch (e) { return null; }
  }
  function kitBuilding(inst) {
    var kp = window.HGN && window.HGN.kitProgress;
    if (!kp || typeof kp.read !== 'function') return false;
    var st = null;
    try { st = kp.read(); } catch (e) { return false; }
    var inCart = {};
    ((inst.cart && inst.cart.items) || []).forEach(function (it) {
      var bt = String(((it && it.properties) || {})._bundle_type || '');
      TIERS.forEach(function (t) { if (bt.indexOf(t + '-starter-kit') === 0) inCart[t] = true; });
    });
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      try { if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) continue; } catch (e) {}
      var kit = st && st.kits && st.kits[t];
      var picks = (kit && kit.items && kit.items.length) || 0;
      var acc = 0;
      try { acc = Object.keys((kit && kit.accessories) || {}).filter(function (k) { return !!kit.accessories[k]; }).length; } catch (e) {}
      if (picks > 0 || acc > 0) {
        /* complete and not yet in the cart = finalisable by the panel, not "building" */
        var f = null;
        try { f = typeof window.HGN.kitFinaliseState === 'function' ? window.HGN.kitFinaliseState(t) : null; } catch (e) {}
        if (f && f.ready && f.unfilled === 0 && !inCart[t]) continue;
        return true;
      }
    }
    return false;
  }
  function busy(inst) {
    if (S.phase === 'closing' || S.scrubbing) return true;
    if (inst._checkoutInflight || inst._mintInflight || inst._kitCheckoutPending || inst._giftInflight ||
        inst._adHocApplyInflight || inst._kit5GateInflight || inst._perfAsking) return true;
    if (inst._perfStep && inst._perfStep.open) return true;
    if (inst.checkoutBtn && inst.checkoutBtn.disabled) return true;
    try { if (typeof inst._welcomeApplyPending === 'function' && inst._welcomeApplyPending()) return true; } catch (e) {}
    return false;
  }
  function eligibility(inst) {
    var cart = inst.cart;
    var readyKit = cart ? readyKitTier(inst) : null;
    if (!cart || (!cart.item_count && !readyKit)) return { ok: false, why: 'empty' };
    if (typeof inst._expressCheckout !== 'function' || typeof H.setExpressCodes !== 'function') return { ok: false, why: 'core' };
    if (!inst.footEl || inst.footEl.hidden || !inst.checkoutBtn || inst.checkoutBtn.hidden) return { ok: false, why: 'foot' };
    if (inst._checkoutMintFailed) return { ok: false, why: 'mint-failed' };
    if (busy(inst)) return { ok: false, why: 'busy' };
    if (kitBuilding(inst)) return { ok: false, why: 'kit' };
    if (!readyKit) {
      try { if (typeof inst._emptyKitFootState === 'function' && inst._emptyKitFootState()) return { ok: false, why: 'kit' }; } catch (e) {}
      try { if (typeof inst._findUnfinalisedReadyKit === 'function' && inst._findUnfinalisedReadyKit()) return { ok: false, why: 'kit' }; } catch (e) {}
    }
    /* Our own app (Capacitor, html.hgn-app): Apple Pay / Google Pay are
       hidden in its web view and PayPal is neither supported there nor on
       allowNavigation (research §4) — kept out until tested in the app. */
    try { if (document.documentElement.classList.contains('hgn-app')) return { ok: false, why: 'app' }; } catch (e) {}
    /* A Nail Drop subscription line rides its own checkout story. */
    try { if (typeof inst._hasDropLine === 'function' && inst._hasDropLine()) return { ok: false, why: 'drop' }; } catch (e) {}
    /* The meaty rule: only where we'd rather they paid now than kept browsing. */
    var c = cfg();
    var units = 0, kit = false;
    (cart.items || []).forEach(function (it) {
      if (isGift(it)) return;
      units += parseInt(it.quantity, 10) || 0;
      if (isKitLine(it)) kit = true;
    });
    if (kit || readyKit) return { ok: true, reason: 'kit' };
    if (units >= c.minUnits) return { ok: true, reason: 'units' };
    if (c.minSubtotalGbp > 0 && typeof inst._lastDisplayedSubtotalCents === 'number') {
      var line = 0;
      try { line = Math.round(inst._convertThreshold(c.minSubtotalGbp) * 100); } catch (e) { line = Math.round(c.minSubtotalGbp * 100); }
      if (line > 0 && inst._lastDisplayedSubtotalCents >= line) return { ok: true, reason: 'subtotal' };
    }
    return { ok: false, why: 'small' };
  }

  /* ── Wallets ─────────────────────────────────────────────────────────
     snippets/hgn-side-cart.liquid ships Shopify's row in a <template>; it
     is cloned into the panel only for arm B, so `off` and arm A carry no
     wallet markup at all. Shopify's start-up script (on every page) waits
     for the element to appear and starts it (research §1). In the DOM it
     stays laid out but visibility:hidden + inert until verified (never
     display:none). "Rendered" = the row has real height, stable for
     WALLET_STABLE_MS; none (e.g. an in-app browser with no wallet) keeps
     the entry hidden. */
  function walletHost() { return S.el && S.el.area ? S.el.area.querySelector('[data-hgn-express-wallets]') : null; }
  function cloneWallets() {
    if (S.walletCloned || !S.el || !S.el.tpl || !S.el.area) return;
    S.walletCloned = true;
    try {
      var frag = S.el.tpl.content ? S.el.tpl.content.cloneNode(true) : null;
      if (!frag) return;
      S.el.area.insertBefore(frag, S.el.area.firstChild);
      var host = walletHost();
      if (!host) return;
      host.setAttribute('aria-hidden', 'true');
      try { host.inert = true; } catch (e) {}
      host.setAttribute('inert', '');
      /* A tap inside Shopify's (closed) row lands on our host: remember it,
         so an outside click during a wallet's own sheet/pop-up can't close
         the drawer and scrub the code under it. */
      host.addEventListener('pointerdown', function () { S.walletTapAt = Date.now(); }, true);
      host.addEventListener('click', function () { S.walletTapAt = Date.now(); }, true);
      if (typeof window.ResizeObserver === 'function') {
        try { new ResizeObserver(function () { measureWallets(); schedule(); }).observe(host); } catch (e) {}
      }
      var n = 0;
      (function tick() {
        measureWallets();
        schedule();
        if (++n < 40 && !walletReady()) setTimeout(tick, 500);
      })();
    } catch (e) { log('wallet clone failed', e); }
  }
  function measureWallets() {
    var host = walletHost();
    var h = 0;
    if (host) {
      try { h = host.getBoundingClientRect().height || 0; } catch (e) { h = 0; }
    }
    var now = Date.now();
    if (h >= WALLET_MIN_PX) {
      if (!(S.walletH >= WALLET_MIN_PX) || Math.abs(h - S.walletH) > 2) S.walletStableSince = now;
    } else {
      S.walletStableSince = 0;
    }
    S.walletH = h;
    if (S.walletStableSince && now - S.walletStableSince < WALLET_STABLE_MS && !S.measureT) {
      S.measureT = setTimeout(function () { S.measureT = null; measureWallets(); schedule(); }, WALLET_STABLE_MS - (now - S.walletStableSince) + 30);
    }
    return h;
  }
  /* Wallet marks on the entry button (16 Oct, Matt: "show the logos of the
     methods that are available"). Shopify renders each wallet as its own
     light-DOM element (seen on the copy theme: shop-pay-wallet-button,
     shopify-paypal-button, shopify-google-pay-button); the entry shows the
     snippet's official icon for each one PRESENT on this device, in Shopify's
     order, and falls back to the text caption when none can be matched. */
  var MARK_OF = [[/shop-?pay/, 'shopify_pay'], [/apple-?pay/, 'apple_pay'], [/google-?pay/, 'google_pay'], [/paypal/, 'paypal']];
  var MARK_NAME = { shopify_pay: 'Shop Pay', apple_pay: 'Apple Pay', google_pay: 'Google Pay', paypal: 'PayPal' };
  /* The wallets Shopify actually rendered here, in its order. */
  function seenWallets() {
    var host = walletHost();
    var seen = [];
    if (!host) return seen;
    host.querySelectorAll('*').forEach(function (n) {
      var t = n.tagName ? n.tagName.toLowerCase() : '';
      if (t.indexOf('-') === -1) return;
      for (var i = 0; i < MARK_OF.length; i++) {
        if (MARK_OF[i][0].test(t) && seen.indexOf(MARK_OF[i][1]) === -1) seen.push(MARK_OF[i][1]);
      }
    });
    return seen;
  }
  function paintMarks() {
    try {
      var entry = S.el && S.el.entry;
      var marks = entry && q('[data-hgn-express-marks]', entry);
      var host = walletHost();
      if (!marks || !host) return;
      var seen = seenWallets();
      /* Touch the DOM only when the wallet set changes. The foot's
         MutationObserver re-runs evaluate() on any change here, so an
         unconditional repaint moved the tiles every 30 ms, and a real click
         or tap never opened the panel (Chrome cancels a click whose pressed
         element is removed before release; iOS Safari drops a tap when
         content changes under the finger). */
      var sig = seen.join(',');
      if (sig === S.marksSig) return;
      S.marksSig = sig;
      var shown = [];
      marks.querySelectorAll('[data-hgn-express-mark]').forEach(function (m) { m.hidden = true; });
      seen.forEach(function (type) {
        var m = q('[data-hgn-express-mark="' + type + '"]', marks);
        if (m) { m.hidden = false; marks.appendChild(m); shown.push(MARK_NAME[type]); }
      });
      marks.hidden = !shown.length;
      /* has-marks = the branded wallet tiles (CSS); without a matched wallet
         the entry stays the plain outlined "Express checkout" button. */
      entry.classList.toggle('has-marks', !!shown.length);
      var cap = q('[data-hgn-express-caption]', entry);
      if (cap) cap.hidden = !!shown.length;
      if (S.el.openBtn) {
        if (shown.length) S.el.openBtn.setAttribute('aria-label', COPY.entry + ': ' + shown.join(', '));
        else S.el.openBtn.removeAttribute('aria-label');
      }
    } catch (e) {}
  }
  function walletReady() {
    return S.walletH >= WALLET_MIN_PX && !!S.walletStableSince && Date.now() - S.walletStableSince >= WALLET_STABLE_MS;
  }

  /* ── DOM ─────────────────────────────────────────────────────────────── */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function bind(inst) {
    if (S.el) return;
    var root = inst.root;
    var sheet = root && q('[data-hgn-express]', root);
    var entry = root && q('[data-hgn-express-entry]', root);
    if (!sheet || !entry) return;
    S.el = {
      sheet: sheet, entry: entry,
      openBtn: q('[data-hgn-express-open]', entry),
      scrim: q('[data-hgn-express-scrim]', root),
      title: q('[data-hgn-express-title]', sheet),
      closeBtn: q('[data-hgn-express-close]', sheet),
      payLabel: q('[data-hgn-express-pay-label]', sheet),
      payValue: q('[data-hgn-express-pay-value]', sheet),
      save: q('[data-hgn-express-save]', sheet),
      saveLabel: q('[data-hgn-express-save-label]', sheet),
      saveValue: q('[data-hgn-express-save-value]', sheet),
      items: q('[data-hgn-express-items]', sheet),
      itemsValue: q('[data-hgn-express-items-value]', sheet),
      ship: q('[data-hgn-express-ship]', sheet),
      shipValue: q('[data-hgn-express-ship-value]', sheet),
      status: q('[data-hgn-express-status]', sheet),
      area: q('[data-hgn-express-area]', sheet),
      tpl: q('template[data-hgn-express-tpl]', sheet),
      fail: q('[data-hgn-express-fail]', sheet),
      regular: q('[data-hgn-express-regular]', sheet)
    };
    var E = S.el;
    /* Page-level layer (17 Oct, Matt: "why can't it just render the drawer?"): the panel and its
       scrim move to <body> so a dock or a card can open Express WITHOUT the side cart. Moved here,
       before Shopify's wallet row is cloned in, so the wallets never re-initialise. role="dialog"
       on the layer keeps the side cart's outside-click and focus guards off it when the drawer is
       open as well (both exempt [role="dialog"]). */
    var layer = document.createElement('div');
    layer.className = 'hgn-express-layer';
    layer.setAttribute('data-hgn-express-layer', '');
    layer.setAttribute('role', 'dialog');
    layer.setAttribute('aria-modal', 'true');
    layer.setAttribute('aria-labelledby', 'hgn-side-cart-express-title');
    layer.setAttribute('aria-hidden', 'true');
    if (E.scrim) layer.appendChild(E.scrim);
    layer.appendChild(sheet);
    document.body.appendChild(layer);
    E.layer = layer;
    function txt(el, t) { if (el) el.textContent = t; }
    txt(q('[data-hgn-express-label]', entry), COPY.entry);
    txt(q('[data-hgn-express-caption]', entry), COPY.entrySub);
    txt(E.title, COPY.title);
    txt(E.fail, COPY.unavailable);
    txt(E.regular, COPY.regular);
    txt(q('[data-hgn-express-items-label]', sheet), COPY.items);
    txt(q('[data-hgn-express-ship-label]', sheet), COPY.delivery);
    if (E.closeBtn) E.closeBtn.setAttribute('aria-label', COPY.close);
    if (E.openBtn) E.openBtn.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
    if (E.closeBtn) E.closeBtn.addEventListener('click', function (e) { e.preventDefault(); closePanel('close'); });
    if (E.scrim) E.scrim.addEventListener('click', function (e) { e.preventDefault(); closePanel('scrim'); });
    if (E.regular) E.regular.addEventListener('click', function (e) { e.preventDefault(); regular(); });
    /* The foot's own state changes (busy labels, disabled, the mint-failed
       note, the kit CTA swap) re-evaluate the entry. */
    if (inst.footEl && typeof window.MutationObserver === 'function') {
      try {
        new MutationObserver(function () { schedule(); }).observe(inst.footEl, {
          subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'disabled']
        });
      } catch (e) {}
    }
  }

  function setSheet(state) {
    var E = S.el;
    if (!E) return;
    E.sheet.setAttribute('data-state', state);
    var shown = state !== 'closed';
    if (E.layer) E.layer.setAttribute('aria-hidden', shown ? 'false' : 'true');
    document.documentElement.classList.toggle('hgn-express-open', shown);
    E.sheet.setAttribute('aria-hidden', shown ? 'false' : 'true');
    try { E.sheet.inert = !shown; } catch (e) {}
    if (shown) E.sheet.removeAttribute('inert'); else E.sheet.setAttribute('inert', '');
    if (E.scrim) E.scrim.hidden = !shown;
    /* Everything behind the sheet is out of reach while it's up. */
    var panel = S.inst && S.inst.panel;
    if (panel) {
      ['.hgn-side-cart__head', '[data-hgn-side-cart-progress]', '[data-hgn-side-cart-body]', '[data-hgn-side-cart-foot]'].forEach(function (sel) {
        var el = q(sel, panel);
        if (!el) return;
        try { el.inert = shown; } catch (e) {}
        if (shown) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
    }
    var wallets = state === 'ready' ? 'open' : (state === 'failed' ? 'gone' : 'locked');
    E.sheet.setAttribute('data-wallets', wallets);
    var host = walletHost();
    if (host) {
      var live = wallets === 'open';
      host.setAttribute('aria-hidden', live ? 'false' : 'true');
      try { host.inert = !live; } catch (e) {}
      if (live) host.removeAttribute('inert'); else host.setAttribute('inert', '');
    }
    if (E.fail) E.fail.hidden = state !== 'failed';
    stateChanged();
  }
  function setStatus(text) {
    if (!S.el || !S.el.status) return;
    S.el.status.textContent = text || '';
    S.el.status.hidden = !text;
  }
  /* ── Delivery (Matt, 16 Oct) ───────────────────────────────────────────
     A wallet adds delivery on top of the cart, so the panel shows it first
     and the amount in the wallet's sheet is the one the panel said.
     Free: a free-delivery code on the cart (KITSHIP-/DROPSHIP-), or
     Shopify's verified total at or over this market's threshold (the
     drawer's own converted, rounded-up figure, so "Free" never shows
     where Shopify charges). Otherwise the announcement bar's GBP Standard
     charge, converted the way Shopify converts it: at Shopify's rate, to
     the penny, then rounded up per currency. Measured on the copy, 16 Oct:
     GBP 2.99 · EUR 3.95 · CHF 4 · USD 5 · CAD 6 · AUD 6 · NZD 8 · DKK 28 ·
     SEK 41 · PLN 16 · CZK 88. A currency not measured (or no Shopify rate
     to hand): "Added at payment", never a guess. */
  var FEE_ROUND = { EUR: 'x95', CHF: 'unit', USD: 'unit', CAD: 'unit', AUD: 'unit', NZD: 'unit', DKK: 'unit', SEK: 'unit', PLN: 'unit', CZK: 'unit' };
  /* The drawer's shipThresholdKey (assets/hgn-side-cart.js), same order. */
  function shipKey(shipping, cur) {
    cur = String(cur || 'gbp').toLowerCase();
    var cc = (window.HGN_COPY && window.HGN_COPY.cc) || '';
    if (cur !== 'gbp' && shipping[cur] != null) return cur;
    if (cc && cc !== 'GB' && shipping.eur != null) return 'eur';
    return 'gbp';
  }
  function feeCents(gbp, cur) {
    if (!isFinite(gbp) || gbp < 0) return null;
    if (cur === 'GBP') return Math.round(gbp * 100);
    var rule = FEE_ROUND[cur];
    var sc = window.Shopify && window.Shopify.currency;
    if (!rule || !sc || String(sc.active || '').toUpperCase() !== cur) return null;
    var rate = parseFloat(sc.rate);
    if (!isFinite(rate) || rate <= 0) return null;
    var c = Math.round(gbp * rate * 100);
    if (rule === 'unit') return Math.ceil(c / 100) * 100;
    var u = Math.floor(c / 100) * 100 + 95;   /* x95: the next .95 at or above */
    return u >= c ? u : u + 100;
  }
  function delivery(inst, totalCents, codes) {
    if ((codes || []).some(function (c) { return /^(KITSHIP|DROPSHIP)-/i.test(c); })) return { kind: 'free', cents: 0 };
    if (typeof totalCents !== 'number' || !isFinite(totalCents)) return { kind: 'unknown' };
    var conf = inst.config || {};
    var shipping = conf.shipping || {};
    var cur = String((inst.cart && inst.cart.currency) || 'GBP').toUpperCase();
    var lineGbp = parseFloat(shipping[shipKey(shipping, cur)]);
    if (isFinite(lineGbp) && lineGbp > 0) {
      var line = 0;
      try { line = Math.round(inst._convertThreshold(lineGbp) * 100); } catch (e) { line = 0; }
      if (line > 0 && totalCents >= line) return { kind: 'free', cents: 0 };
    }
    var fee = feeCents(parseFloat(conf.shippingRateGbp != null ? conf.shippingRateGbp : 2.99), cur);
    if (fee == null) return { kind: 'unknown' };
    return fee === 0 ? { kind: 'free', cents: 0 } : { kind: 'fee', cents: fee };
  }

  /* The drawer's own foot figures, verbatim (label + value) — until the
     wallets are revealed. Then Shopify's verified total as Items, the
     delivery, and To pay = what the wallet's sheet will charge. */
  function fillFigures(inst) {
    var E = S.el;
    if (!E) return;
    var tl = inst.totalsEl && q('.hgn-side-cart__totals-label', inst.totalsEl);
    var footLabel = tl ? tl.textContent : 'Subtotal';
    var footValue = inst.subtotalEl ? inst.subtotalEl.textContent : '';
    var d = (S.phase === 'ready' && typeof S.total === 'number') ? delivery(inst, S.total, S.applied) : null;
    S.ship = d ? d.kind : null;
    var known = !!d && d.kind !== 'unknown';
    var cur = inst.cart && inst.cart.currency;
    function money(c) { return typeof H.formatMoney === 'function' ? H.formatMoney(c, cur) : ''; }
    if (E.items) E.items.hidden = !known;
    if (E.itemsValue && known) E.itemsValue.textContent = money(S.total);
    if (E.ship) E.ship.hidden = !d;
    if (E.shipValue && d) E.shipValue.textContent = d.kind === 'fee' ? money(d.cents) : (d.kind === 'free' ? COPY.free : COPY.atPayment);
    if (E.payLabel) E.payLabel.textContent = known ? COPY.toPay : footLabel;
    if (E.payValue) E.payValue.textContent = known ? money(S.total + (d.cents || 0)) : footValue;
    var hasSave = !!(inst.savingsEl && !inst.savingsEl.hidden && inst.savingsValueEl && inst.savingsValueEl.textContent);
    if (E.save) E.save.hidden = !hasSave;
    if (hasSave) {
      var sl = q('.hgn-side-cart__savings-label', inst.savingsEl);
      if (E.saveLabel) E.saveLabel.textContent = sl ? sl.textContent : 'You save';
      if (E.saveValue) E.saveValue.textContent = inst.savingsValueEl.textContent;
    }
  }

  /* ── Entry + eligible event ─────────────────────────────────────────── */
  var schedT = null;
  function schedule() {
    if (schedT) return;
    schedT = setTimeout(function () { schedT = null; evaluate(); }, 30);
  }
  function evaluate() {
    var inst = S.inst;
    if (!inst || !S.el) return;
    var a = arm();
    if (!a) { if (!S.el.entry.hidden) S.el.entry.hidden = true; return; }
    if (a === 'B') cloneWallets();
    var el = eligibility(inst);
    if (el.ok && inst.isOpen && !S.eligibleLogged) {
      S.eligibleLogged = true;
      offer('eligible', { reason: el.reason });
    }
    var show = a === 'B' && el.ok && !S.open && walletReady();
    if (show) paintMarks();
    if (S.el.entry.hidden === show) S.el.entry.hidden = !show;
    stateChanged();
  }

  /* ── Open → chain → apply → verify → reveal ──────────────────────────── */
  function withCap(p, ms, fallback) {
    return new Promise(function (resolve) {
      var t = setTimeout(function () { resolve(fallback); }, ms);
      Promise.resolve(p).then(function (v) { clearTimeout(t); resolve(v); }, function () { clearTimeout(t); resolve(fallback); });
    });
  }
  function warmUp() {
    return withCap(fetch('/checkout', { credentials: 'same-origin', redirect: 'follow', cache: 'no-store' }).catch(function () {}), WARM_CAP_MS, null);
  }
  /* Refund a panel-minted NAILPOINTS-* (the existing _clearNailPointsState
     path, keeping the shopper's Nail Points choice) when it can no longer be
     reused: different basket, or older than 50 min. */
  function npSettle(inst, force) {
    var rec = npRecord();
    if (!rec || !rec.code) return Promise.resolve();
    var minted = typeof inst._getMintedNailPointsCode === 'function' ? inst._getMintedNailPointsCode() : null;
    if (!minted || up(minted) !== up(rec.code)) { ssDel(NP_KEY); return Promise.resolve(); }
    var stale = force || rec.sig !== npSig(inst) || (Date.now() - (rec.at || 0)) >= NP_REUSE_MS;
    if (!stale) return Promise.resolve();
    ssDel(NP_KEY);
    log('refunding panel Nail Points code', rec.code);
    return Promise.resolve(inst._clearNailPointsState({ keepIntent: true })).catch(function () {})
      .then(function () { return inst.refresh(); });
  }
  /* Before the chain: a minted NAILPOINTS-* is reused only inside the rule
     (same basket, < 50 min, minted by this panel); otherwise it's refunded
     first and the chain mints a fresh one, exactly as a first tap would. */
  function npBeforeChain(inst) {
    if (typeof inst._getDiscountIntent !== 'function' || inst._getDiscountIntent() !== 'nailpoints') return Promise.resolve();
    var minted = inst._getMintedNailPointsCode();
    if (!minted) return Promise.resolve();
    var rec = npRecord();
    var reusable = rec && up(rec.code) === up(minted) && rec.sig === npSig(inst) && (Date.now() - (rec.at || 0)) < NP_REUSE_MS;
    if (reusable) return Promise.resolve();
    ssDel(NP_KEY);
    return Promise.resolve(inst._clearNailPointsState({ keepIntent: true })).catch(function () {})
      .then(function () { return inst.refresh(); });
  }
  function readyReason(codes) {
    var value = codes.filter(function (c) { return !/^(KITSHIP|DROPSHIP)-/i.test(c); });
    if (!codes.length) return 'none';
    if (value.some(function (c) { return /^(NAILPOINTS|BEANS)-/i.test(c); })) return 'np';
    if (value.some(function (c) { return /^BASKET-/i.test(c); })) return 'basket';
    if (!value.length) return 'ship';
    return 'code';
  }

  /* Opening with a complete kit still in the builder: add it to the bag first —
     the same hgn:kit:finalise-request + wait the foot's "Checkout with my kit"
     uses (_finaliseKitThenCheckout), including its free-gift wait — then the
     chain runs on a cart that holds it. S.sig is null meanwhile, so the kit's
     own lines landing never read as a basket change. Resolves true (added, or
     nothing to add) / false (no kit after 15 s: stock modal, 422 retry…). */
  function finaliseReadyKit(inst) {
    var tier = readyKitTier(inst);
    if (!tier) return Promise.resolve(true);
    setStatus(COPY.adding);
    return new Promise(function (resolve) {
      var done = false;
      function hasKit(cart) {
        return ((cart && cart.items) || []).some(function (it) {
          return String(((it && it.properties) || {})._bundle_type || '').indexOf(tier + '-starter-kit') === 0;
        });
      }
      function finish(ok) {
        if (done) return;
        done = true;
        document.removeEventListener('hgn:cart:change', onChange);
        resolve(ok);
      }
      function onChange(e) {
        var cart = e && e.detail && e.detail.cart;
        if (!cart || !hasKit(cart)) return;
        if (inst._giftInflight && !(cart.items || []).some(isGift)) return;
        finish(true);
      }
      document.addEventListener('hgn:cart:change', onChange);
      try { document.dispatchEvent(new CustomEvent('hgn:kit:finalise-request', { detail: { tier: tier, source: 'express' } })); }
      catch (e) { finish(false); return; }
      setTimeout(function () { finish(false); }, 15000);
    });
  }

  function openPanel() {
    var inst = S.inst;
    if (!inst || S.open || S.scrubbing || !S.el) return;
    if (arm() !== 'B' || !eligibility(inst).ok || !walletReady()) { schedule(); return; }
    var run = ++S.run;
    S.open = true;
    /* Standalone = opened over the page with the side cart shut (dock / card). The drawer stays
       shut for the whole run: the kit's own add and auto-finalise would otherwise open it
       (the add interceptor and HGN.sideCart.open() both check holdsDrawer()). */
    S.standalone = !inst.isOpen;
    S.opener = document.activeElement;
    if (S.standalone) window.__hgnExpressHold = true;
    S.phase = 'minting';
    S.sig = null;
    S.npSigOpen = null;
    S.keep = [];
    S.lastResult = null;
    S.total = null;
    S.el.entry.hidden = true;
    offer('open', {});
    fillFigures(inst);
    setSheet('minting');
    setStatus(COPY.preparing);
    setTimeout(function () { try { if (S.open && S.el.title) S.el.title.focus({ preventScroll: true }); } catch (e) {} }, 60);
    var preNp = null;
    var kitAdded = true;
    Promise.resolve(inst.refresh())
      .then(function () { if (run === S.run) return finaliseReadyKit(inst); })
      .then(function (ok) { kitAdded = ok !== false; if (run === S.run && kitAdded) return inst.refresh(); })
      .then(function () { if (run === S.run && kitAdded) return npBeforeChain(inst); })
      .then(function () {
        if (run !== S.run) return null;
        if (!kitAdded) return { ok: false, reason: 'kit-add' };
        S.sig = lineSig(inst.cart);
        S.npSigOpen = npSig(inst);
        fillFigures(inst);
        var el = eligibility(inst);
        if (!el.ok) return { ok: false, reason: 'not-eligible:' + el.why };
        preNp = typeof inst._getMintedNailPointsCode === 'function' ? inst._getMintedNailPointsCode() : null;
        if ((inst._lastSavingsGbpCents || 0) > 0 || inst._getDiscountIntent()) setStatus(COPY.securing);
        return withCap(inst._expressCheckout(function () { setStatus(COPY.securing); }), CHAIN_CAP_MS, { ok: false, reason: 'chain-timeout' });
      })
      .then(function (res) {
        if (!res) return;
        S.lastResult = res;
        /* A fresh panel NAILPOINTS-* mint: remember it for the 50-min reuse. */
        if (res.ok) {
          var np = (res.codes || []).filter(function (c) { return /^(NAILPOINTS|BEANS)-/i.test(c); })[0];
          if (np && up(np) !== up(preNp || '')) ssSet(NP_KEY, JSON.stringify({ code: np, sig: S.npSigOpen || npSig(inst), at: Date.now() }));
        }
        if (run !== S.run) { npSettle(inst); return; }
        if (!res.ok) { failPanel(res.reason); return; }
        if (lineSig(inst.cart) !== S.sig) { closePanel('cart-change'); return; }
        return apply(inst, run, res);
      })
      .catch(function (e) {
        log('open failed', e);
        if (run === S.run && S.open) failPanel('error');
      });
  }

  function apply(inst, run, res) {
    var codes = (res.codes || []).slice();
    var expect = res.expectTotalCents;
    var c = cfg();
    if (typeof expect !== 'number' || !isFinite(expect)) { failPanel('no-figure'); return; }
    S.phase = 'applying';
    fillFigures(inst);
    var want = codes.map(up);
    var cur = String((inst.cart && inst.cart.currency) || 'GBP').toUpperCase();
    var allowBelow = false;
    try { allowBelow = inst._getDiscountIntent() === 'adhoc' && inst._getAdHocClass() === 'product'; } catch (e) {}
    /* The money maths ignores these codes from the moment they can be on
       the cart (a render racing the apply stays neutral). */
    setApplied(codes);
    var step = Promise.resolve();
    if (codes.length && c.warmCheckout === 'before') step = step.then(warmUp);
    return step
      .then(rawCart)
      .then(function (cart) {
        if (run !== S.run) return null;
        if (!cart) return { ok: false, reason: 'cart-read' };
        if (lineSig(cart) !== S.sig) return { ok: false, reason: 'cart-change' };
        /* Codes already there that we keep (a GSF-* parity code the chain
           left on a no-saving basket). Stale HGN value codes are dropped. */
        S.keep = (cart.discount_codes || []).map(function (d) { return d && d.code; }).filter(function (code) {
          return code && want.indexOf(up(code)) === -1 && !/^(BASKET|NAILPOINTS|BEANS)-/i.test(code);
        });
        var body = { attributes: { _hgn_express: '1' } };
        /* Full list in one call: right whether /cart/update.js {discount}
           ADDS or REPLACES (the chain's scrub already ran). */
        if (codes.length) body.discount = S.keep.concat(codes).join(',');
        S.attrSet = true;
        /* The scrub waits for this write: a close racing the apply must not
           read the cart before the codes land on it. */
        var w = S.pendingWrite = postUpdate(body);
        return w.then(function (ok) {
          if (S.pendingWrite === w) S.pendingWrite = null;
          if (!ok) return { ok: false, reason: 'apply-http' };
          return verify(run, want, expect, cur, allowBelow);
        });
      })
      .then(function (v) {
        if (!v || run !== S.run) return;
        if (!v.ok) {
          log('verify failed', v);
          if (v.reason === 'cart-change') { closePanel('cart-change'); return; }
          failPanel(v.reason);
          return;
        }
        S.total = v.total;
        var w = (codes.length && c.warmCheckout === 'after') ? warmUp() : null;
        return Promise.resolve(w).then(function () {
          if (run !== S.run || !S.open) return;
          reveal(inst, codes);
        });
      })
      .catch(function (e) {
        log('apply failed', e);
        if (run === S.run && S.open) failPanel('apply-error');
      });
  }

  /* Poll /cart.js (≤ verifyMs) until every expected code is present with
     applicable === true and total_price is within 1p of the drawer's foot.
     Two documented allowances, both only ever in the shopper's favour:
     a non-GBP BASKET-* is a percentage rounded UP to 4 dp by the worker
     (≤ subtotal × 0.0001 extra); a product-class ad-hoc code takes money
     off lines the drawer can't preview. */
  function verify(run, want, expect, cur, allowBelow) {
    var deadline = Date.now() + cfg().verifyMs;
    var last = { ok: false, reason: 'verify-timeout' };
    function check(cart) {
      if (!cart) return { ok: false, reason: 'verify-no-cart' };
      if (lineSig(cart) !== S.sig) return { ok: false, reason: 'cart-change' };
      var have = {};
      (cart.discount_codes || []).forEach(function (d) { if (d && d.code) have[up(d.code)] = d; });
      for (var i = 0; i < want.length; i++) {
        var d = have[want[i]];
        if (!d) return { ok: false, reason: 'verify-missing', code: want[i] };
        if (d.applicable !== true) return { ok: false, reason: 'verify-inapplicable', code: want[i] };
      }
      var keepU = S.keep.map(up);
      for (var k in have) {
        if (!Object.prototype.hasOwnProperty.call(have, k)) continue;
        if (want.indexOf(k) === -1 && keepU.indexOf(k) === -1 && have[k].applicable === true) return { ok: false, reason: 'verify-extra-code', code: k };
      }
      var total = cart.total_price;
      if (typeof total !== 'number') return { ok: false, reason: 'verify-no-total' };
      var diff = total - expect;   /* > 0: Shopify would charge MORE than the drawer shows */
      if (Math.abs(diff) <= 1) return { ok: true, total: total };
      if (diff < 0) {
        var pctTol = (cur !== 'GBP' && want.some(function (c) { return /^BASKET-/.test(c); }))
          ? Math.ceil((cart.items_subtotal_price || 0) * 0.0001) + 1 : 0;
        if (-diff <= pctTol) return { ok: true, total: total, allowance: 'pct-rounding' };
        if (allowBelow) return { ok: true, total: total, allowance: 'product-code' };
      }
      return { ok: false, reason: 'verify-total', total: total, expect: expect };
    }
    return new Promise(function (resolve) {
      (function poll() {
        if (run !== S.run) { resolve(null); return; }
        rawCart().then(function (cart) {
          var v = check(cart);
          last = v;
          if (v.ok || v.reason === 'cart-change' || Date.now() >= deadline) { resolve(v); return; }
          setTimeout(poll, POLL_MS);
        });
      })();
    });
  }

  function reveal(inst, codes) {
    S.phase = 'ready';
    fillFigures(inst);
    setStatus('');
    setSheet('ready');
    measureWallets();
    offer('ready', { reason: readyReason(codes) });
    log('wallets revealed', codes);
  }

  function failPanel(reason) {
    if (!S.open) return;
    S.phase = 'failed';
    setStatus('');
    setSheet('failed');
    offer('failed', { reason: String(reason || 'unknown').split(':')[0] });
    log('express unavailable:', reason);
    /* Take back whatever we put on the cart; the panel stays up with the
       regular-checkout button. */
    if (S.applied.length || S.attrSet) scrub(S.inst);
    try { if (S.el.regular) S.el.regular.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ── Close / scrub ───────────────────────────────────────────────────── */
  function scrub(inst) {
    if (S.scrubbing) return S.scrubbing;
    var codes = S.applied.slice();
    var attr = S.attrSet;
    if (!codes.length && !attr) { setApplied([]); return Promise.resolve(); }
    var p = Promise.resolve(S.pendingWrite).catch(function () {})
      .then(rawCart)
      .then(function (cart) {
        var steps = Promise.resolve();
        if (codes.length && typeof H.clearStaleBasketCodes === 'function') {
          steps = steps.then(function () { return H.clearStaleBasketCodes(cart, { also: codes, joined: true }); });
        }
        if (attr) steps = steps.then(function () { return postUpdate({ attributes: { _hgn_express: '' } }); });
        return steps;
      })
      .then(function () { return codes.length ? rawCart() : null; })
      .then(function (cart) {
        /* One more pass if a code survived (a write lost to a race). */
        if (!cart) return null;
        var want = codes.map(up);
        var left = (cart.discount_codes || []).some(function (d) { return d && d.code && want.indexOf(up(d.code)) !== -1; });
        if (left) return H.clearStaleBasketCodes(cart, { also: codes, joined: true });
        return null;
      })
      .catch(function (e) { log('scrub error', e); })
      .then(function () {
        S.applied = [];
        S.attrSet = false;
        setApplied([]);
        S.scrubbing = null;
        return inst && inst.refresh ? inst.refresh() : null;
      })
      .then(function () { schedule(); });
    S.scrubbing = p;
    return p;
  }

  function closePanel(reason, opts) {
    var inst = S.inst;
    if (!S.open) return S.scrubbing || Promise.resolve();
    S.open = false;
    S.run++;
    S.phase = 'closing';
    S.total = null;
    S.lastReason = reason;
    if (opts && opts.instant && S.el) S.el.sheet.setAttribute('data-instant', '');
    setStatus('');
    setSheet('closed');
    if (S.el) setTimeout(function () { S.el.sheet.removeAttribute('data-instant'); }, 50);
    offer('closed', { reason: reason });
    S.surface = '';
    if (S.standalone) {
      S.standalone = false;
      window.__hgnExpressHold = false;
      try { if (S.opener && S.opener.isConnected && !(inst && inst.isOpen)) S.opener.focus({ preventScroll: true }); } catch (e) {}
    }
    var p = scrub(inst)
      .then(function () { return reason === 'cart-change' ? npSettle(inst, true) : npSettle(inst); })
      .catch(function () {})
      .then(function () { S.phase = 'idle'; schedule(); });
    try {
      var target = (S.el && !S.el.entry.hidden && S.el.openBtn) || (inst && inst.checkoutBtn);
      if (target && inst && inst.isOpen && reason !== 'drawer' && reason !== 'pageshow') target.focus({ preventScroll: true });
    } catch (e) {}
    return p;
  }

  /* "Or use regular checkout": the panel's codes come off first, then
     today's Checkout tap runs unchanged (finish-kit prompt, perf step, mint,
     warm-up, /checkout?discount=…). */
  function regular() {
    var inst = S.inst;
    if (!inst) return;
    offer('regular', {});
    closePanel('regular').then(function () {
      try {
        if (inst.isOpen) { inst._handleCheckout(); return; }
        inst.open();
        setTimeout(function () { try { inst._handleCheckout(); } catch (e) { log('regular checkout failed', e); } }, 380);
      } catch (e) { log('regular checkout failed', e); }
    });
  }

  /* ── Hooks into the side cart ────────────────────────────────────────── */
  function boot(inst) {
    if (S.inst) return;
    S.inst = inst;
    bind(inst);
    /* Codes a previous page left on the cart (reload / navigation while the
       panel held them): take them off now. */
    try {
      var left = JSON.parse(ssGet(APPLIED_KEY) || '[]');
      if (left && left.length) {
        S.applied = left;
        S.attrSet = true;
        if (typeof H.setExpressCodes === 'function') H.setExpressCodes(left);
        scrub(inst);
      }
    } catch (e) {}
  }

  var origRender = P._render;
  P._render = function () {
    var out = origRender.apply(this, arguments);
    try { boot(this); schedule(); } catch (e) {}
    return out;
  };

  /* The drawer closing closes the panel (and scrubs). Exception: for a few
     minutes after a wallet tap, an OUTSIDE click (a wallet's own overlay or
     pop-up hand-off) doesn't close the drawer, so the code stays under the
     wallet that is using it. × and Escape still close. */
  document.addEventListener('pointerdown', function (e) {
    try {
      var panel = S.inst && S.inst.panel;
      if (panel && !panel.contains(e.target)) S.lastOutsideDown = Date.now();
    } catch (x) {}
  }, true);
  var origClose = P.close;
  P.close = function () {
    try {
      if (S.open && S.phase === 'ready' && S.walletTapAt && Date.now() - S.walletTapAt < HOLD_MS &&
          Date.now() - S.lastOutsideDown < 600) {
        log('outside click held: a wallet was just tapped');
        return;
      }
      if (S.open && !S.standalone) closePanel('drawer');
    } catch (e) {}
    return origClose.apply(this, arguments);
  };
  var origOpen = P.open;
  P.open = function () {
    var out = origOpen.apply(this, arguments);
    try { schedule(); } catch (e) {}
    return out;
  };

  /* Escape closes the panel only (not the drawer behind it). */
  window.addEventListener('keydown', function (e) {
    if (!S.open || e.key !== 'Escape') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    closePanel('escape');
  }, true);

  /* Any change to what's in the basket while the panel is up: hide the
     wallets, scrub, settle Nail Points. Discount / attribute-only changes
     (the chain's own writes, the arm stamp) are not basket changes. */
  document.addEventListener('hgn:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (S.open && S.sig !== null && cart && lineSig(cart) !== S.sig) {
      closePanel('cart-change');
      return;
    }
    schedule();
  });
  document.addEventListener('hgn:kit:change', schedule);

  /* Back/forward cache: the page comes back with the panel frozen open —
     close it and take the codes off. */
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    S.walletTapAt = 0;
    if (S.open) { closePanel('pageshow', { instant: true }); return; }
    if ((S.applied.length || S.attrSet) && S.inst) scrub(S.inst);
    else {
      try {
        var left = JSON.parse(ssGet(APPLIED_KEY) || '[]');
        if (left && left.length && S.inst) { S.applied = left; S.attrSet = true; scrub(S.inst); }
      } catch (x) {}
    }
  });

  window.HGN.express = {
    COPY: COPY,
    /* `off` lets the arm beacon skip this family while it's switched off. */
    off: switchedOff,
    state: function () {
      var inst = S.inst;
      return {
        arm: arm(), open: S.open, phase: S.phase, applied: S.applied.slice(), attrSet: S.attrSet,
        entryShown: !!(S.el && !S.el.entry.hidden), walletH: S.walletH, walletReady: walletReady(),
        walletCloned: S.walletCloned, eligible: inst ? eligibility(inst) : null,
        lastReason: S.lastReason, lastResult: S.lastResult, total: S.total, ship: S.ship, neutral: typeof H.expressCodes === 'function' ? H.expressCodes() : null
      };
    },
    open: function () { openPanel(); },
    close: function (reason) { return closePanel(reason || 'api'); },
    /* For HGN.sideCart.state() (SIDE-CART-API-2026-10-17.md §2).
       qualifies = the basket passes the panel's own rule (meaty, not busy,
       no kit building…) whatever the arm; eligible = the entry would show
       now (arm B, qualifies, Shopify's wallets rendered, panel shut). */
    snapshot: function () {
      var inst = S.inst;
      var a = arm();
      var el = inst ? eligibility(inst) : { ok: false, why: 'boot' };
      return {
        arm: a, qualifies: !!el.ok, why: el.ok ? el.reason : el.why,
        eligible: a === 'B' && !!el.ok && walletReady() && !S.open && !S.scrubbing,
        wallets: seenWallets(), open: S.open, phase: S.phase
      };
    },
    /* Open the drawer straight into the panel, from any surface. `surface`
       tags every event of this open (dock-lp, card-lp…). Not offerable →
       the drawer stays open as normal. */
    openFrom: function (surface) {
      var inst = S.inst;
      if (!inst) return;
      S.surface = surface || surfaceFor('drawer');
      openPanel();
      if (!S.open) { S.surface = ''; inst.open(); }
    },
    /* True while a standalone panel runs: HGN.sideCart.open() and the add interceptor leave the
       drawer shut. */
    holdsDrawer: function () { return !!(S.open && S.standalone); },
    /* Harness / console only. */
    _instance: function () { return S.inst; }
  };
})();
